import script from "./Viewed.vue?vue&type=script&setup=true&lang=js"
export * from "./Viewed.vue?vue&type=script&setup=true&lang=js"

import "./Viewed.vue?vue&type=style&index=0&id=1b0a2bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b0a2bca"]])

export default __exports__